import React from 'react';

function MainFeat() {
  return (
    <section
      className="main-feat section-padding bg-img"
      data-background="/light/assets/imgs/header/bg-4.png"
      data-overlay-dark="9"
    >
      <div className="container">
        <div className="sec-head mb-80">
          <div className="row justify-content-between">
            <div className="col-lg-6 md-mb50">
              <h6 className="sub-title main-color mb-15">Our Programmes</h6>
              <h2 className="fw-600 fz-70">
                How Each Initiative <span className="fw-300">Creates Impact</span>
              </h2>
            </div>
            <div className="col-lg-5 d-flex align-items-end">
              <div className="text full-width pb-40 bord-thin-bottom">
                <p>
                  Each SPOB initiative is built around a specific community need, delivered
                  through trained volunteers, local partners, and evidence-based approaches
                  that put people at the centre of every solution.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="row justify-content-between">
          <div className="col-lg-6">
            <div className="img md-mb50">
              <img
                src="/light/assets/imgs/spob/spob-5.jpg"
                alt="SPOB initiatives in action"
                className="radius-15"
              />
            </div>
          </div>
          <div className="col-lg-5">
            <div className="row">
              <div className="col-md-6">
                <div className="item mb-50">
                  <h5 className="mb-15">Health Outreach</h5>
                  <ul className="rest dot-list">
                    <li className="mb-10">Free health screenings</li>
                    <li className="mb-10">Maternal &amp; child health</li>
                    <li className="mb-10">Community health education</li>
                    <li>Medical referral support</li>
                  </ul>
                </div>
                <div className="item sm-mb50">
                  <h5 className="mb-15">School Uniform Equity</h5>
                  <ul className="rest dot-list">
                    <li className="mb-10">Uniform provision for pupils</li>
                    <li className="mb-10">Back-to-school drives</li>
                    <li className="mb-10">Partner school enrolment</li>
                    <li>Dignity &amp; inclusion focus</li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6">
                <div className="item mb-50">
                  <h5 className="mb-15">Academic Support</h5>
                  <ul className="rest dot-list">
                    <li className="mb-10">After-school tutoring</li>
                    <li className="mb-10">Learning materials supply</li>
                    <li className="mb-10">Literacy &amp; numeracy focus</li>
                    <li>Teacher support grants</li>
                  </ul>
                </div>
                <div className="item">
                  <h5 className="mb-15">Vocational Skills</h5>
                  <ul className="rest dot-list">
                    <li className="mb-10">Trade &amp; craft training</li>
                    <li className="mb-10">Entrepreneurship workshops</li>
                    <li className="mb-10">Youth unemployment programmes</li>
                    <li>Starter toolkit grants</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MainFeat;
